module.exports = __webpack_public_path__ + "img/ic-arrow-right-pink.bd9b8c57.svg";